const CopyIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 2 9 H 1 V 2 C 1 1.4 1.4 1 2 1 H 9 V 2 H 2 V 9 Z M 14 5 V 14 H 5 V 5 H 14 Z M 5 4 H 14 C 14.6 4 15 4.4 15 5 V 14 C 15 14.6 14.6 15 14 15 H 5 C 4.4 15 4 14.6 4 14 V 5 C 4 4.4 4.4 4 5 4 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default CopyIcon;
